import React, { useRef, useEffect, useState } from "react"
import { Button, Card, Popconfirm, Tree } from "antd";
import { YhBox } from '@/components/YhBox'
import { YhForm } from '@/components/YhFormBox';
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { useOrgModel } from "../orgModel"
import { IOrganDetail, OptType } from "../orgTypes"
import { useNavModel } from "../../../../model/navModel";

const OrganForm = () => {
    const formRef = useRef<IYhFormRef>()
    const { treeSource, root, organTreeRowKey, addTreeFrom, optType, organTreeRow, loadData, setOrganTreeRow, setOrganTreePRow, setRoot, setOrganTreeRowKey, changeTreeForm, insertTreeForm, updataTreeForm, addPeerTreeForm, setAddTreeFrom } = useOrgModel()
    const { selectedNavId, addNav, closeNav, getSelectedNavState } = useNavModel()
    const [peerAndSon, setPeerAndSon] = useState(-1)

    useEffect(() => {
        formRef.current?.resetFields();
        setPeerAndSon(optType)
    }, [optType])

    // 监听 organTreeRow 变化，更新表单数据
    useEffect(() => {
        if (optType === OptType.DETAIL && organTreeRow?.code) {
            // 修改模式下，当 organTreeRow 更新时，重新设置表单值
            formRef.current?.setFieldsValue(organTreeRow);
        }
    }, [organTreeRow])

    const item = [
        {
            type: FormItemTypeEnum.Input,
            fieldLabel: "数据版本号",
            fieldName: "ver",
            span: 24,
            disable: true,
        }, {
            type: FormItemTypeEnum.Input,
            fieldLabel: "父级编码",
            fieldName: "pcode",
            disable: true,
            span: 24,
        }, {
            type: FormItemTypeEnum.Input,
            fieldLabel: "机构编码",
            fieldName: "code",
            span: 24,
            rules: [{ required: true, message: '该项为必填项' }]
        }, {
            type: FormItemTypeEnum.Input,
            fieldLabel: "机构名称",
            fieldName: "name",
            span: 24,
            rules: [{ required: true, message: '该项为必填项' }]

        }, {
            type: FormItemTypeEnum.Input,
            fieldLabel: "备注",
            fieldName: "note",
            span: 24,
        },
    ]

    const onFinish = async () => {
        try {
            if (optType === OptType.ADD_ROOT || optType === OptType.ADD_SAME_LEVEL || optType === OptType.ADD_CHILD_LEVEL) {
                await addPeerTreeForm();
                // 新增成功后重置表单
                formRef.current?.resetFields();
                setAddTreeFrom({}); // 清空新增表单数据
            }
            if (optType === OptType.DETAIL) {
                await updataTreeForm();
                // 修改成功后不需要重置表单，数据会在 loadData 后自动更新
            }
        } catch (error) {
            console.error('操作失败:', error);
        }
    }

    const onChange = (value: any) => {
        if (optType == OptType.DETAIL) {
            changeTreeForm(value)
        } else {
            insertTreeForm(value)
        }
    }

    const formConfig: IYhForm = {
        formRef: formRef,
        labelCol: { span: 6 },
        disabled: false,
        formValues: peerAndSon === OptType.DETAIL ? { ...organTreeRow } : { ...addTreeFrom },
        items: item,
        onFinish: onFinish,
        onChange: onChange
    }

    const onOk = () => {
        formRef.current?.inst().submit()
    }

    const reset = () => {
        formRef.current?.resetFields()
        setOrganTreeRowKey([])
        setOrganTreeRow({})
        setOrganTreePRow({})
        setAddTreeFrom({})
        setRoot(false)
    }

    return <>
        <div className="dict-list-header">
            <Button onClick={onOk} shape="round" type="link">{optType != OptType.DETAIL ? "添加" : "修改"}</Button>
            <Button onClick={() => { closeNav("2-5") }} shape="round">取消</Button>
        </div>
        <div className="dict-from-content">
            <YhForm {...formConfig} />
        </div>
    </>
}

export default OrganForm